export default class Cookies {
    public static readonly LOGIN_HINT = 'amzn-idp-login-hint';
    public static readonly PERSON_ID = 'amzn-idp-login-person-id';
    public static readonly USERNAME = 'amzn-idp-login-username';
    public static readonly SESSION_ID = 'amzn-idp-login-session-id';
    public static readonly REFERRER = 'amzn-idp-login-referrer';
    public static readonly CURRENT_PAGE = 'amzn-idp-login-current-page';
    public static readonly PREVIOUS_PAGE = 'amzn-idp-login-previous-page';
}
